<template>
  <div class="regulations-block">
    <h3 class="regulations-block__title">{{ $t('view.flow.block.regulations.title') }}</h3>
    <div class="regulations-block__wrapper">
      <sw-button
        v-model="val.value"
        :label="$t('common.value')"
        :onText="$t('common.accepted')"
        :offText="$t('common.rejected')"
        alwaysActive
        @input="onInput"
      ></sw-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.regulations-block {
  @include flowElementShadow();
  width: 20%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;
}
</style>
